import { generateAvatarList } from './generator'

/**
 * Avatar list for organizations.
 * Currently uses the default avatar path, but can be customized in the future
 * when organization-specific assets are available.
 *
 * To customize when assets are ready:
 * generateAvatarList({ pathPrefix: 'avatar/organization/' })
 */
export const organizationAvatarList = generateAvatarList()
